import type { Account, Observations, Tenant } from './api';

// A refresh counter and display names do not change the authorized data boundary.
export function tenantBoundary(tenant?: Tenant | null): string {
  return tenant ? JSON.stringify([tenant.tenantId, String(tenant.dataGeneration), tenant.customerId, tenant.contractId, tenant.role]) : '';
}

export function retainObservations(current: Observations | null, grant?: Tenant): Observations | null {
  return current && grant && tenantBoundary(current.tenant) === tenantBoundary(grant) ? current : null;
}

// These values describe the selected account's persisted snapshot, rather than
// the fresh object returned by every membership check.
export function wafSnapshotIdentity(account?: Account): string {
  return account ? JSON.stringify([account.accountId, account.lastSyncedAt ?? null, account.syncStatus,
    account.waf?.checkedAt ?? null, account.waf?.lastAttemptAt ?? null, account.waf?.status ?? null]) : '';
}

export function evidenceRefreshPlan(previousSource: string | null, source: string, cursor?: string) {
  const resetPage = previousSource !== source;
  return { resetPage, deferRequest: resetPage && cursor !== undefined };
}

export function resolveAclSelection(selected: string, keys: string[]): string {
  return keys.includes(selected) ? selected : keys[0] || '';
}

/** Keep an in-flight full-page read alive while still reacting immediately to changed grants. */
export function membershipNeedsRefresh(prior: Tenant | undefined, next: Tenant | undefined, loading: boolean): boolean {
  return tenantBoundary(prior) !== tenantBoundary(next) || !loading;
}
